import './shared';

import './plugins/hash';
import './plugins/wizard';

import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery.css';
import lgVideo from 'lightgallery/plugins/video'
import lgHash from 'lightgallery/plugins/hash'

import 'owl.carousel/dist/owl.carousel.min';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';

import '../styles/inner_index.css';

const _dir = $('html').attr('dir');
const _isRtl = (_dir === 'rtl');


((
    ($) => {
        const _gal = document.getElementById('gallery-w');
        lightGallery(_gal, {
            selector: '.gallery-item',
            customSlideName: true,
            galleryId: $(_gal).attr('data-gal-id'),
            plugins: [lgVideo, lgHash]
        });


        $('#city').on('change', function () {
            var city_id = this.value;
            let dropdown = $('#town');
            dropdown.html('<option value="">.........</option>');
            const url = '/get_area_by_city/' + city_id;
            $.getJSON(url, function (data) {
                $.each(data, function (key, entry) {
                    console.log(key, entry);
                    if (_isRtl) {
                        dropdown.append($('<option></option>').attr('value', entry.id).text(entry.title_ar));
                    } else {
                        dropdown.append($('<option></option>').attr('value', entry.id).text(entry.title_en));
                    }
                })
            });
        });


        $('#training_request_reason').on('change', function () {
            if (this.value === "personal") {
                $('#university_training_application_div').hide();
            } else {
                $('#university_training_application_div').show();
            }
        });


        $(window).on('load', function () {
            let h3count = $('.financing-tabs li').length;
            let jobsH3 = $('.jobs_tabs li').length;
            if (h3count > 0) {
                let h3Titles = $('.inner-body-desc h3');
                h3Titles.each(function (i, obj) {
                    $('h3:eq(' + i + ')').attr('id', 'section_fa_' + i);
                });
            }
            if (jobsH3 > 0) {
                let h3Titles = $('.inner-body-desc h3');
                h3Titles.each(function (i, obj) {
                    $('h3:eq(' + i + ')').attr('id', 'section_fa_' + i);
                });
            }
        });

        $('.financing-tabs li > a[href*="#"]:not(.tab)').on('click', function (e) {
            console.log($(this).attr('href'));
            $(this).attr('class', 'active');
            $('.financing-tabs li a').removeClass('active');
            $(this).attr('class', 'active');
            let Li_href = $(this).attr('href');
            let h3Titles = $('.inner-body-desc h3');
            h3Titles.each(function (i, obj) {
                console.log(obj, i);
                if (Li_href === '#about_financing') {
                    $('html, body').animate({scrollTop: $('#section_fa_0').offset().top - 200}, 'fast');
                }
                if (Li_href === '#financing_purposes') {
                    $('html, body').animate({scrollTop: $('#section_fa_1').offset().top - 200}, 'fast');
                }
                if (Li_href === '#feature') {
                    $('html, body').animate({scrollTop: $('#section_fa_2').offset().top - 200}, 'fast');
                }
                if (Li_href === '#eligibility') {
                    $('html, body').animate({scrollTop: $('#section_fa_3').offset().top - 200}, 'fast');
                }
                if (Li_href === '#requirements') {
                    $('html, body').animate({scrollTop: $('#section_fa_4').offset().top - 200}, 'fast');
                }
                if (Li_href === '#warranties') {
                    $('html, body').animate({scrollTop: $('#section_fa_5').offset().top - 200}, 'fast');
                }
                if (Li_href === '#calculator') {
                    $('html, body').animate({scrollTop: $('#section_calculator').offset().top - 200}, 'fast');
                }
                if (Li_href === '#success_story') {
                    $('html, body').animate({scrollTop: $('#section_success_story').offset().top - 200}, 'fast');
                }
            });
        });

        $('.jobs_tabs li > a[href*="#"]:not(.tab)').on('click', function (e) {
            console.log($(this).attr('href'));
            $(this).attr('class', 'active');
            $('.jobs_tabs li a').removeClass('active');
            $(this).attr('class', 'active');
            let Li_href = $(this).attr('href');
            let h3Titles = $('.inner-body-desc h3');
            h3Titles.each(function (i, obj) {
                console.log(obj, i);
                if (Li_href === '#faten_work_environment') {
                    $('html, body').animate({scrollTop: $('#section_fa_0').offset().top - 200}, 'fast');
                }
                if (Li_href === '#faten_work_advantages') {
                    $('html, body').animate({scrollTop: $('#section_fa_1').offset().top - 200}, 'fast');
                }
                if (Li_href === '#how_to_join_us') {
                    $('html, body').animate({scrollTop: $('#section_fa_2').offset().top - 200}, 'fast');
                }
                if (Li_href === '#training_request') {
                    $('html, body').animate({scrollTop: $('#section_fa_3').offset().top - 200}, 'fast');
                }
            });
        });


        // $('.inner-body-content .tabs-list li > a[href*="#"]:not(.tab)').on('click', function (e) {
        //     const _id = $(this).attr('href');
        //     const _id_last = _id.substring(1, _id.length);
        //     const _content = $(`[id="${_id_last}"]`);
        //
        //     $('html, body').animate({scrollTop: _content.offset().top - 200}, 'fast');
        // });

        $('.item7-head').on('click', function () {
            const _parent = $(this).closest('.item7');
            const _body = _parent.find('.item7-body');
            if (!_parent.hasClass('open')) {
                _parent.addClass('open');
                _body.stop().slideDown('fast');
            } else {
                _parent.removeClass('open');
                _body.stop().slideUp('fast');
            }
        });


        // $(".owl-success-stories").owlCarousel({
        //     rtl: _isRtl,
        //     margin: 50,
        //     items: 5,
        //     autoWidth: true,
        //     dots: true,
        //     nav: false,
        //     autoplay: false,
        //     loop: false,
        //     autoplayTimeout: 5000,
        //     responsive: {
        //         0: {
        //             margin: 0,
        //             items: 1,
        //         },
        //         576: {
        //             margin: 30,
        //             items: 2,
        //         },
        //         768: {
        //             margin: 30,
        //             items: 3,
        //         },
        //         992: {
        //             margin: 30,
        //             items: 4,
        //         },
        //         1200: {
        //             margin: 50,
        //             items: 4,
        //         }
        //     },
        //     onInitialized: function (event) {
        //         const element = event.target;
        //         $(element).closest('.loading').removeClass('loading');
        //
        //         const _items = $(element).find('.owl-item.active .success-story-item');
        //         const _first_item = _items.first();
        //         _first_item.addClass('active');
        //
        //         $('.success-story-item').hover(function () {
        //             const _item = $(this);
        //             if (!_item.hasClass('active')) {
        //                 _items.removeClass('active');
        //                 _item.addClass('active');
        //             }
        //         }, function () {
        //             const _item = $(this);
        //             _item.removeClass('active');
        //             _first_item.addClass('active');
        //         });
        //     }
        // });

        // $('.item10-w').each(function (index, wrapper) {
        //     const _items = $(wrapper).find('.item10.success-story');
        //     const _first_item = _items.first();
        //     _first_item.addClass('active');
        //
        //     _items.hover(function () {
        //         const _item = $(this);
        //         if (!_item.hasClass('active')) {
        //             _items.removeClass('active');
        //             _item.addClass('active');
        //         }
        //     }, function () {
        //         const _item = $(this);
        //         _item.removeClass('active');
        //         _first_item.addClass('active');
        //     });
        // });

        (function () {
            var searchTerm, panelContainerId;
            // Create a new contains that is case insensitive
            jQuery.expr[':'].containsCaseInsensitive = function (n, i, m) {
                return jQuery(n).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
            };

            jQuery('#faq_search_bar').on('change keyup paste click', function () {
                searchTerm = jQuery(this).val();
                if (searchTerm.length >= 3) {
                    jQuery($(this).closest('.tab-content').find('.item7')).each(function () {
                        panelContainerId = '#' + jQuery(this).attr('id');
                        jQuery(panelContainerId + ':not(:containsCaseInsensitive(' + searchTerm + '))').closest('.item7-col').hide();
                    });
                } else {
                    jQuery($(this).closest('.tab-content').find('.item7')).closest('.item7-col').show();
                }
            });
        }());

        function storiesCarousel() {
            var checkWidth = $(window).width();
            var owlPost = $(".stories-carousel");
            if (checkWidth > 767) {
                if (typeof owlPost.data('owl.carousel') != 'undefined') {
                    owlPost.data('owl.carousel').destroy();
                }
                owlPost.removeClass('owl-carousel owl-theme');
            } else if (checkWidth < 768) {
                owlPost.addClass('owl-carousel owl-theme');
                owlPost.owlCarousel({
                    rtl: _isRtl,
                    items: 1,
                    slideSpeed: 500,
                    animateOut: 'fadeOut',
                    touchDrag: false,
                    mouseDrag: false,
                    autoplay: true,
                    autoplaySpeed: 8000,
                    autoplayTimeout: 8000,
                    dots: true,
                    loop: true,
                    arrow: true
                });
            }
        }

        storiesCarousel();
        $(window).resize(storiesCarousel);
    }
)
(jQuery));
